export default __webpack_public_path__ + "static/8-better-credit-cards-ba0fcb694be0bc7cf47e0530aa31f8a1.jpg";